import AutoCompleteFilter from "../../../../../components/AutoCompleteFilter";
import baseService from "../../../../../services/baseService";

export const inputsFiltersGroups = ({ localFilterValues, handleFilterChange }) => [
    {
        label: "Nome",
        component: (
            <AutoCompleteFilter
                service={baseService}
                columnDataBase="name"
                model="group"
                value={localFilterValues.name}
                onChange={(selected) => handleFilterChange("name", selected)}
                placeholder="Filtre os grupos pelo nome"
                isMulti
                isClearable
            />
        ),
    },
];
    